export default {
	methods: {
		async logout() {
			await this.$store.dispatch("logout");
			await this.$router.push("/");
		}
	}
};
